import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import queryParams from '../constants/queryParams';
import { ControlledTabs } from '../components/basics/Tabs';
import { FILTER_CATEGORIES } from '../constants/operations';

const CATEGORY_TABS = FILTER_CATEGORIES.map((category) => ({
  value: category,
  display: <span className="text-capitalize">{category ?? 'All'}</span>,
}));

const useOpCategoryTabs = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeCategory, setActiveCategory] = useState(
    searchParams.get(queryParams.CATEGORY) === 'null'
      ? null
      : searchParams.get(queryParams.CATEGORY) || CATEGORY_TABS[0].value,
  );

  useEffect(() => {
    setSearchParams(
      (params) => {
        const newParams = new URLSearchParams(params);
        newParams.set(queryParams.CATEGORY, activeCategory);
        return newParams;
      },
      { replace: true },
    );
  }, [activeCategory, setSearchParams]);

  return {
    opCategoryTabs: (
      <ControlledTabs
        tabs={CATEGORY_TABS}
        onTabChange={setActiveCategory}
        activeTab={activeCategory}
      />
    ),
    activeCategory,
  };
};

export default useOpCategoryTabs;
